const LOYALTY_AUTH_BASE = "https://retail.soccerbet.rs/loyalty/auth"; // test: 10.0.90.58:7259 | prod: https://retail.soccerbet.rs/loyalty/auth

export const CREATE_ACCOUNT = `${LOYALTY_AUTH_BASE}/registration`;
export const CHECK_OTP = `${LOYALTY_AUTH_BASE}/check-otp`;
export const RESET_PASSWORD = `${LOYALTY_AUTH_BASE}/reset-password`;
export const LOGIN = `${LOYALTY_AUTH_BASE}/sign-in`;
export const CHANGE_PASSWORD_LOGGED_IN_USER = `${LOYALTY_AUTH_BASE}/change-password`;
export const CHANGE_PASSWORD_NOT_LOGGED_IN_USER = `${LOYALTY_AUTH_BASE}/create-or-changed-password`;

export const LOYALTY_API_BASE = "https://jackpot.soccerbet.rs";
